"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var get = require("lodash/get");
var KEYWORD_DEV_TO_PROVIDE = 'devToProvide';
var GAEventManager = /** @class */ (function () {
    function GAEventManager(event) {
        this.event = event;
        this.devOverrides = {};
    }
    GAEventManager.init = function (config) {
        window.analytics = __assign({}, window.analytics, { config: config });
    };
    GAEventManager.prototype.fire = function (trigger, devOverrides) {
        this.devOverrides = devOverrides;
        var gaEvents = sessionStorage.getItem("gaEvents");
        gaEvents = gaEvents ? gaEvents.split(",") : [];
        gaEvents.push(trigger);
        sessionStorage.setItem("gaEvents", gaEvents.toString());
        try {
            var mergedEvent = this.merge();
            if (mergedEvent) {
                if (Object.keys(window.analytics).length && !window.analytics.config.disabled) {
                    window.analytics.track(trigger, mergedEvent);
                }
                else {
                    console.log("GA Event: ", trigger, mergedEvent.event);
                }
            }
        }
        catch (err) {
            // tslint:disable-next-line:no-console
            console.error(err.message, trigger);
            return;
        }
    };
    GAEventManager.prototype.getValue = function (path) {
        var originalValue = get(this.event, path);
        if (originalValue === KEYWORD_DEV_TO_PROVIDE) {
            var overrideValue = get(this.devOverrides, path);
            if (overrideValue === null || overrideValue === undefined) {
                console.error("One of the devToProvide fields is missing - " + path);
            }
            return overrideValue;
        }
        return originalValue;
    };
    GAEventManager.prototype.merge = function () {
        return {
            schema_type: this.getValue('schema_type'),
            event: {
                name: this.getValue('event.name'),
                category: this.getValue('event.category'),
                label: this.getValue('event.label'),
                value: this.getValue('event.value') || -1,
                nonInteraction: this.getValue('event.nonInteraction') || false,
                properties: this.getValue('event.properties'),
            }
        };
    };
    return GAEventManager;
}());
exports.GAEventManager = GAEventManager;
//# sourceMappingURL=GoogleAnalytics.js.map